import request from "../web-sh/src/utils/request";
import user from '../web-sh/src/services/user';
import global from "../config/global";
import coreServices from "./core";
import common from "../utils/common";

async function get_me() {
  return request({
    url: global.endpoint.SSO_ME,
    method: "get",
  });
}

async function update_me(data) {
  return request({
    url: global.endpoint.SSO_ME,
    method: "put",
    data
  });
}

async function delete_me(data) {
  return request({
    url: global.endpoint.USERS_ME_DELETE,
    method: "post",
    data
  });
}

async function block_by_2fa() {
  return request({
    url: global.endpoint.USERS_ME_BLOCK_BY_2FA,
    method: "get",
  });
}

async function password_hint(data) {
  return request({
    url: global.endpoint.USERS_PASSWORD_HINT,
    method: "post",
    data
  });
}

async function register(data = {
  email,
  full_name,
  login_method,
  password,
  password_hint,
  kdf,
  kdf_iterations,
  kdf_memory,
  kdf_parallelism
}) {
  const makeKey = await coreServices.make_key(
    data.email,
    data.password,
    data.kdf,
    data.kdf_iterations,
    data.kdf_memory,
    data.kdf_parallelism
  )
  const encKey = await global.jsCore.cryptoService.makeEncKey(makeKey)
  const keys = await global.jsCore.cryptoService.makeKeyPair(encKey[0])
  const hashedPassword = await global.jsCore.cryptoService.hashPassword(data.password, makeKey)
  const { score } = common.getPasswordStrength(data.password)
  let payload = {
    name: data.full_name,
    email: data.email,
    kdf: data.kdf,
    kdf_iterations: data.kdf_iterations,
    kdf_memory: data.kdf_memory,
    kdf_parallelism: data.kdf_parallelism,
    master_password_hash: hashedPassword,
    master_password_hint: data.password_hint || "",
    key: encKey[1].encryptedString,
    keys: {
      public_key: keys[0],
      encrypted_private_key: keys[1].encryptedString,
    },
    score: score,
    is_trial_promotion: false,
    login_method: data.login_method
  }
  const trialPlan = common.getTrialPlan();
  if (trialPlan) {
    payload['trial_plan'] = trialPlan;
  }
  return await request({
    url: global.endpoint.USERS_REGISTER,
    method: "post",
    data: payload
  }).then(() => {
    common.removeTrialPlan();
  });
}

export default {
  ...user,
  get_me,
  update_me,
  delete_me,
  password_hint,
  block_by_2fa,
  register
};
